export const Code = ({ className, children }) => (
  <code className={`f6 i ph1 bg-white o-80 ${className ? className : ''}`}>{children}</code>
);
